export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_8-6c287aa302c77f0340a740e7c9a61fdb.jpg";